module.exports = __webpack_public_path__ + "static/media/btn_parents_05_training_workshop.42a8837c.png";